import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import ReusablePagination from 'components/commom/Pagination';
import CommonToast from 'components/commom/CommonToast';
import LabelWithInput from 'components/commom/LabelWithInput';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import { CircularProgress, Tooltip } from '@mui/material';
import { staffDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import {
  basicDetailsValue,
  PARTICULAR_STAFF,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import { getMasterData } from 'store/masterData/masterDataAction';
import { getLocationCallAPI } from 'store/Enterprise/enterprise/getLocation/action';
import moment from 'moment';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getStaffCallAPI } from 'store/Enterprise/staff/getStaff/action';
import CreateStaff from 'Pages/Admin/Enterprise/EnterpriseDetail/CreateStaff';
import { resendInviteCallAPI } from 'store/Enterprise/staff/resendInvite/action';

const EnterpriseStaff = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    search: '',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [selectedDate, setSelectedDate] = useState({
    id: 'Today',
    name: 'Today',
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;

  const staffList = useSelector((state) => state?.getStaffReducer?.users?.data);
  const staffLoader = useSelector((state) => state?.getStaffReducer?.loading);
  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );
  const resendLoader = useSelector(
    (state) => state?.resendInviteReducer?.loading
  );

  const selectDateList = [
    {
      id: 'Today',
      name: 'Today',
    },
    {
      id: 'Yesterday',
      name: 'Yesterday',
    },
    {
      id: 'Last 7 Days',
      name: 'Last 7 Days',
    },
    {
      id: 'Last 15 Days',
      name: 'Last 15 Days',
    },
    {
      id: 'Last 30 Days',
      name: 'Last 30 Days',
    },
    {
      id: 'Custom',
      name: 'Custom',
    },
  ];

  useEffect(() => {
    getData(1, moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
    getGenderData();
    getLocationData();
    setLoading(true);
  }, []);

  const getGenderData = () => {
    dispatch(
      getMasterData(
        {
          run: true,
          handleFunction: (res) => {},
          error: true,
          handleErrorFunction: (res) => {},
        },
        'gender'
      )
    );
  };

  const getLocationData = () => {
    dispatch(
      getLocationCallAPI(enterpriseData?.enterprise?.enterprise_id, {
        run: true,
        handleFunction: (res) => {},
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const getData = (page = 1, startDate, endDate) => {
    const body = {
      id: enterpriseData?.enterprise?.enterprise_id,
      detail: `${formData?.search ? `?search_text=${formData?.search}` : `?page=${page}`}&start_date=${startDate}&end_date=${endDate}`,
    };
    dispatch(
      getStaffCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          setLoading(false);
          setCount(Math.ceil(res?.count / itemsPerPage));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
          setLoading(false);
        },
      })
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (e) => {
    setSelectedDate(e?.target?.value);

    switch (e?.target?.value?.id) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        break;
      case 'Custom':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));
      default:
        break;
    }
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getData(value, formData?.startDate, formData?.endDate);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    getData(1, formData?.startDate, formData?.endDate);
  };

  const handleApply = () => {
    getData(page, formData?.startDate, formData?.endDate);
  };

  const handleDetail = (data) => {
    dispatch(basicDetailsValue(PARTICULAR_STAFF, data));
    navigate(staffDetail(locale));
  };

  const handleResend = (data) => {
    const body = {
      id: data?.id,
      detail: {},
    };
    dispatch(
      resendInviteCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              Staff Members
            </h2>
          </div>
          {!loading && (
            <div className="flex flex-wrap gap-x-[20px]">
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </div>
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Select Date:'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder={'Select Date'}
                    name={'selectDate'}
                    value={selectedDate?.id || ''}
                    data={selectDateList}
                    onChange={(e) => handleDateChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </div>
              {selectedDate?.id === 'Custom' && (
                <>
                  <div>
                    <LabelWithInput
                      label="Start Date"
                      type="date"
                      name="startDate"
                      value={formData?.startDate}
                      disabled={false}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      marginTop={0}
                      sx={{ mt: 0 }}
                    />
                  </div>
                  <div>
                    <LabelWithInput
                      label="End Date"
                      type="date"
                      name="endDate"
                      value={formData?.endDate}
                      disabled={false}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    />
                  </div>
                </>
              )}
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[48px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </div>
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[48px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setDrawerOpen(true);
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Create</div>
                </div>
              </div>
            </div>
          )}
          {/* {!loading && (
            <Row
              className="mt-3"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-2">
                <div className="mt-[17px] w-full">
                  <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                    {'Select Date:'}
                  </div>
                  <div>
                    <SelectInputBorder
                      placeholder={'Select Date'}
                      name={'selectDate'}
                      value={selectedDate?.id || ''}
                      data={selectDateList}
                      onChange={(e) => handleDateChange(e)}
                      background={'#FFFFFF'}
                      colorIcon={'#292D32'}
                      placeholderColor={'#292D32'}
                    />
                  </div>
                </div>
              </Col>
              <Col md={2} className="mt-5">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[48px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </Col>
              <Col md={6} className="mt-5 justify-content-end d-flex">
                <div
                  className="w-full md:max-w-[30%] lg:max-w-[30%] xl:max-w-[30%] 2xl:max-w-[20%] fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[48px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setDrawerOpen(true);
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Create</div>
                </div>
              </Col>
            </Row>
          )} */}
          {/* {!loading && selectedDate?.id === 'Custom' && (
            <Row
              className="mt-1"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2}>
                <LabelWithInput
                  label="Start Date"
                  type="date"
                  name="startDate"
                  value={formData?.startDate}
                  disabled={false}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  marginTop={0}
                  sx={{ mt: 0 }}
                />
              </Col>
              <Col md={2}>
                <LabelWithInput
                  label="End Date"
                  type="date"
                  name="endDate"
                  value={formData?.endDate}
                  disabled={false}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
              </Col>
            </Row>
          )} */}
          {staffLoader || loading ? (
            <Loader />
          ) : (
            <div className="mt-[30px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Name
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Contact Details
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Gender
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Skin Analyser
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Skin Concern Identifier
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Hair Anayser
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Last Used
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Invite
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {staffList && staffList?.length > 0 ? (
                  [...staffList]
                    ?.sort((a, b) => b?.id - a?.id)
                    .map((item, index) => (
                      <Row
                        className="m-0 p-0 flex items-center listAppointment"
                        key={index}
                      >
                        <Col
                          lg={2}
                          md={6}
                          sm={12}
                          style={{
                            borderLeft: !item?.is_invite_accepted
                              ? '4px solid #F59E0B'
                              : '4px solid #059F3E',
                            cursor: 'pointer',
                            minHeight: '45px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                          onClick={() => {
                            handleDetail(item);
                          }}
                        >
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center break-all">
                            {item?.name}
                          </div>
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all">
                            {item?.location ? item?.location?.location_id : ''}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="pt-04 flex items-center gap-[10px]">
                            {item?.email && (
                              <Tooltip title={item?.email} arrow>
                                <Image
                                  src={mail}
                                  alt="icon"
                                  style={{ cursor: 'pointer' }}
                                />
                              </Tooltip>
                            )}
                            {item?.contact_number && (
                              <Tooltip
                                title={
                                  // item?.country_code +
                                  item?.contact_number
                                }
                                arrow
                              >
                                <Image
                                  src={call}
                                  alt="icon"
                                  style={{ cursor: 'pointer' }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {`${item?.gender}`}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                            {`${item?.skin_analyser_count}`}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                            {`${item?.skin_concern_identifier_count}`}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 text-[#4497EA] family_outfit_regular_400 lh-176 underline">
                            {`${item?.hair_analyser_count}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.lastUsed
                              ? moment(item?.lastUsed)?.format('DD MMM YYYY')
                              : 'NA'}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          {!item?.is_invite_accepted ? (
                            <div
                              className="fs-14 fc-202224 family_outfit_regular_400 lh-176 cursor-pointer"
                              onClick={() => {
                                !resendLoader && handleResend(item);
                              }}
                            >
                              {resendLoader ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                <RefreshIcon sx={{ color: '#375241' }} />
                              )}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    ))
                ) : (
                  <div className="flex flex-col justify-center items-center py-[50px]">
                    <Image
                      src={EmptyScreen}
                      alt="icon"
                      width={'301px'}
                      height={'224px'}
                    />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                )}
              </Row>
            </div>
          )}
          {!staffLoader && !loading && (
            <div className="mt-[20px] flex items-center justify-end gap-[24px]">
              <div className="flex items-center gap-[8px]">
                <div className="h-[18px] w-[18px] bg-[#F59E0B]"></div>
                <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                  Invited
                </div>
              </div>
              <div className="flex items-center gap-[8px]">
                <div className="h-[18px] w-[18px] bg-[#059F3E]"></div>
                <div className="text-[14px] text-[#202224] lh-2 family_outfit_regular_400">
                  Onboarded
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>
      <CreateStaff open={drawerOpen} onClose={handleDrawerClose} />
    </div>
  );
};

export default EnterpriseStaff;
